import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './Wizard.scss';
import Overlay from '../Overlay';
import WizardTiles from './WizardTiles';
import WizardBody from './WizardBody';

import { saveContact } from '../../store/actions/contacts';
import {
  getAllUserTypeRoles,
  fetchAllItemTypes,
} from '../../store/actions/formOptions';
import { selectFormOptions } from '../../store/selectors/formOptions';
import { upload } from '../../helpers/upLoadHelper';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { clearContactFormData } from '../../store/actions/contactForm';
import { clearPropertyFormData } from '../../store/actions/propertyForm';
import { saveProperty } from '../../store/actions/properties';
import { clearItemFormData } from '../../store/actions/itemForm';
import { saveItem } from '../../store/actions/items';
import { clearSelectedModulePermission } from '../../store/actions/tabSelections';
import { exitServiceRequestForm } from '../../store/actions/serviceRequestForm';

class Wizard extends React.Component {
  state = {
    active: null,
  };

  componentDidMount() {
    const {
      getAllUserTypeRoles,
      fetchAllItemTypes,
      formOptions,
      clearSelectedModulePermission,
      onExitServiceRequestForm,
    } = this.props;
    clearSelectedModulePermission();
    // if(formOptions.allRoles.length === 0) {
    getAllUserTypeRoles();
    // }
    if (formOptions.allItemTypes.length === 0) {
      fetchAllItemTypes();
    }
    onExitServiceRequestForm();
  }

  onSubmitContactForm = async (data, actionType) => {
    const { user } = this.props;
    let imageUrl = null;
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }
    let assignedRoles = [];
    if (data.userRole) {
      for (var i = 0; i < this.props.formOptions.allRoles.length; i++) {
        if (data.userRole === this.props.formOptions.allRoles[i].name) {
          assignedRoles.push(this.props.formOptions.allRoles[i].id);
        }
      }
    }
    if (!data.userRole) {
      assignedRoles.push(data.roles[0].role.id);
    }

    let phone = data.phone;
    let cleaned = ('' + phone).replace(/\D/g, '');
    let formattedNumber = cleaned;
    if (cleaned.length === 10) {
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      formattedNumber = match[1] + '-' + match[2] + '-' + match[3];
    }
    let firstChar = data.firstname.charAt(0)?.toUpperCase();
    let slicedName = data.firstname.slice(1, data.firstname.length);
    let firstname = firstChar + slicedName;

    let PropertyId =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? null
        : data.propertyId
          ? data.propertyId
          : null;
    let SuiteId =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? null
        : data.suiteId
          ? data.suiteId
          : null;
    let ServicesProvided =
      data.userRole === 'Service Provider' || data.userRole === 'Vendor'
        ? data.servicesProvided
        : null;

    if (data.id) {
      let params = {
        id: data.id,
        username: data.username,
        email: data.email,
        firstname: data.firstname,
        lastname: data.lastname,
        phone: formattedNumber,
        profileImage: imageUrl != null ? imageUrl : data.profileImage,

        languages: null,
        customerId: null,
        deleted: false,
        assignedRoles: assignedRoles,
        address: data.address,
        UserId: user.id,
        CompanyName: data.companyName,
        isDashboardAccess: data.isDashboardAccess,
      };
      if (data.userRole === 'Service Provider' || data.userRole === 'Vendor') {
        params.ServicesProvided = ServicesProvided;
      }
      if (
        data.userRole === 'Home Owner' ||
        data.userRole === 'Occupant' ||
        data.userRole === 'Realtor'
      ) {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.PropertyId,
        }));
        // params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }

      // this.props.onUpdateContactForm(params)
    } else {
      let params = {
        username: data.email,
        email: data.email,
        firstname: firstname,
        lastname: data.lastname,
        phone: formattedNumber,
        profileImage: imageUrl,

        languages: null,
        customerId: null,

        SentEmail: true,
        assignedRoles: assignedRoles,
        address: data.address,
        UserId: user.id,
        RoleName: data.userRole,
        RoleId: assignedRoles[0],
        CompanyName: data.companyName,
        isDashboardAccess: data.isDashboardAccess,
      };
      if (data.userRole === 'Service Provider' || data.userRole === 'Vendor') {
        params.ServicesProvided = ServicesProvided;
      }
      if (
        data.userRole === 'Home Owner' ||
        data.userRole === 'Occupant' ||
        data.userRole === 'Realtor'
      ) {
        params.Suites = data.Suites.map((a) => ({
          Id: a.Id,
          PropertyId: a.PropertyId,
        }));
        // params.SuiteId = SuiteId;
        params.PropertyId = PropertyId;
        params.isPrimaryContact =
          data && data.isPrimaryContact && data.isPrimaryContact === true
            ? true
            : false;
      }
      if (data.userRole === 'Service Manager') {
        params.PropertyId = PropertyId;
      }
      this.props.onSubmitContactForm(params);
    }
  };

  saveProperty = async (data, actionType) => {
    let params = {};

    let imageUrl = null;
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }
    let stages =
      data.constructionStages && data.constructionStages.length > 0
        ? data.constructionStages.filter((cs) => !cs.new)
        : [];

    params = {
      Name: data.name,
      AddressLine1: data.addressLine1,
      AddressLine2: '',
      City: data.city,
      Province: data.province,
      PostalCode: data.postalCode,
      Latitude: '17.5896',
      Longitude: '17.556896',
      Image: imageUrl,
      UserId: this.props.user.id,
      PropertyManagerId: data.propertyManagerId,
      ConstructionStages: stages,
      modulePermissions: data.modulePermissions || [],
    };

    this.props.onSaveProperty(params);
    //this.props.clearPropertyFormData();
    // if(actionType === 'SaveAndClose') {
    //   this.props.onClose();
    // }
  };

  onSaveItem = (item) => {
    let properties = [];
    if (item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map((sp) => {
        properties = [...properties, { id: sp.value }];
      });
    }
    let params = {
      Name: item.name,
      MakeName: item.makeName,
      Model: item.model,
      TypeId: item.typeId,
      WarrantyYears: item.warrantyYears,
      UserId: this.props.user.id,
      properties: properties,
    };
    this.props.onSaveItem(params);
  };

  onBack = () => {
    this.setState({ active: null });
    this.props.clearPropertyFormData();
    this.props.clearContactFormData();
    this.props.clearItemFormData();
  };
  render() {
    const {
      onClose,
      showOverlay,
      user,
      tabList,
      clearSelectedModulePermission,
    } = this.props;
    const { active } = this.state;
    return (
      <Overlay
        showOverlay={showOverlay}
        content={
          <>
            {active ? (
              <WizardBody
                active={active}
                onBack={() => this.onBack()}
                onClose={() => {
                  this.setState({ active: null });
                  onClose();
                }}
                saveProperty={this.saveProperty}
                onSubmitContactForm={this.onSubmitContactForm}
                onSaveItem={this.onSaveItem}
                tabList={tabList}
              />
            ) : (
              <WizardTiles
                onChange={(active) => {
                  this.setState({ active });
                  clearSelectedModulePermission();
                }}
                onClose={onClose}
                tiles={
                  user.roles[0].role.name === 'Admin' ||
                  user.roles[0].role.name === 'Super Admin'
                    ? ['Service Request', 'Property', 'Contact', 'Item']
                    : ['Service Request', 'Contact', 'Item']
                }
              />
            )}
          </>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  formOptions: selectFormOptions(state),
  user: selectAuthenticatedUser(state),
  tabList: state.tabSelections.tabList,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSubmitContactForm: saveContact,
      onSaveProperty: saveProperty,
      getAllUserTypeRoles,
      clearContactFormData,
      clearPropertyFormData,
      clearItemFormData,
      fetchAllItemTypes,
      onSaveItem: saveItem,
      clearSelectedModulePermission,
      onExitServiceRequestForm: exitServiceRequestForm,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);

// export default Wizard;
